import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardText,
} from "reactstrap";

import { connect } from "react-redux";
import { toast } from "react-toastify";
// import AvaliacaoModal from "./AvaliacaoModal";
import classnames from "classnames";
import TabelaConsultas from "./Components/TabelaConsultas";
import DadosCliente from "./Components/DadosCliente";
import Prontuario from "./Components/Prontuario";
import TabelaExames from "./Components/TabelaExames";

const PerfilCliente = (props) => {
  document.title = "Clientes | Seu Dashboard";

  const [customActiveTab, setCustomActiveTab] = useState("2");
  const [cliente, setCliente] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const id = useParams().id;

  const getClientes = () => {
    fetch(`${process.env.REACT_APP_API}/cliente/${id}`)
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        setCliente(response);
      });
  };

  useEffect(() => {
    getClientes();
  }, []);

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <CardTitle className="h4">Veja os dados do ...</CardTitle>

              <Nav tabs className="nav-tabs-custom">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: customActiveTab === "1",
                    })}
                    onClick={() => {
                      setCustomActiveTab("1");
                    }}
                  >
                    <span className="d-none d-sm-block">Dados do Cliente</span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: customActiveTab === "2",
                    })}
                    onClick={() => {
                      setCustomActiveTab("2");
                    }}
                  >
                    <span className="d-none d-sm-block">Consultas</span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: customActiveTab === "3",
                    })}
                    onClick={() => {
                      setCustomActiveTab("3");
                    }}
                  >
                    <span className="d-none d-sm-block">Prontuários</span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: customActiveTab === "4",
                    })}
                    onClick={() => {
                      setCustomActiveTab("4");
                    }}
                  >
                    <span className="d-none d-sm-block">Exames</span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: customActiveTab === "4",
                    })}
                    onClick={() => {
                      window.location.href = `https://drive.google.com/drive/folders/16UR-xVkHennWO9Nlz8oZO7WxeG-jbNaB`;
                    }}
                  >
                    <span className="d-none d-sm-block">
                      Protocolos de consultas
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                activeTab={customActiveTab}
                className="p-3 text-muted"
              >
                <TabPane tabId="1">
                  {cliente && <DadosCliente cliente={cliente}></DadosCliente>}
                </TabPane>
                <TabPane tabId="2">
                  {cliente && (
                    <TabelaConsultas cliente={cliente}></TabelaConsultas>
                  )}
                </TabPane>
                <TabPane tabId="3">
                  <Prontuario pacienteId={id}></Prontuario>
                </TabPane>
                <TabPane tabId="4">
                  <TabelaExames cliente={cliente}></TabelaExames>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, {})(PerfilCliente);
